import { Button } from "@mui/material";
import { memo, useCallback, useMemo, useState } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import "./LicenseModal.scss";

interface LicenseModalProps {
  buttonClassName: string;
  description: string;
  title: string;
  notice: string;
}

const LicenseModal = (props: LicenseModalProps) => {
  const { buttonClassName, description, title, notice } = props;
  const [modal, setModal] = useState(false);
  const toggle = useCallback(() => setModal((isOpen) => !isOpen), []);

  const htmlToParse = useMemo(() => ({ __html: description }), [description]);

  return (
    <div>
      <Button className={buttonClassName} onClick={toggle}>
        {title}
      </Button>
      <Modal isOpen={modal} size="lg" toggle={toggle} className="license-modal">
        <ModalHeader toggle={toggle} className="license-modal-header">
          {title}
        </ModalHeader>
        <ModalBody className="license-modal-body">
          <p className="license-modal-notice">{notice}</p>
          <hr className="license-modal-divider" />
          <div className="license-modal-terms" dangerouslySetInnerHTML={htmlToParse} />
        </ModalBody>
      </Modal>
    </div>
  );
};

export default memo(LicenseModal);
